enum MainRoutes {
  Root = '/:country',
}

export default MainRoutes
